<template>
<div>
	<gobuy-head :title="$t('Share page')" />
	<span @click="jumpShareList" class="audit-button">{{ $t('Audit result') }} >></span>
	<div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
	<div class="box">
	<img :src="infos.goods_image" class="headerImg2" />
	<div class="headers">
		<div class="header_lf">
		{{ infos.goods_name }}
		</div>
		<div class="headers_mead"></div>
		<div class="headers_rt">$ <span>{{ infos.goods_price }}</span></div>
	</div>
	<div class="mead">
		<div class="mead_tit">
		{{ $t('Share to the community') }} <img @click="clickShareModel" src="../../../assets/image/giftcard/imsharefxicons.png" />
		</div>
		<div class="mead_txt">{{ $t('imshares1') }}</div>
		<div class="mead_txt2">{{ $t('imshares2') }}</div>
		<div class="mead_txt2">{{ $t('imshares3') }}</div>
	</div>
	<div class="upload" @change="onFileChange">
		<div class="fileBox">
		<input type="file" accept="image/*">
		<img :src="imageUrl" v-if="imageUrl">
		<img v-else src="../../../assets/image/giftcard/imshareuploadicons.png" />
		</div>
		<div class="upload_txt">{{ $t('Please upload pictures') }}</div>
	</div>
	<div class="footbtns" @click="submits">{{ $t('Submit') }}</div>
	<div style="height: 80px;"></div>

	<div class="model" v-if="showModel" @click="showModel = false">
		<div class="model_mead" @click.stop>
		<div class="model_mead_box">
			<div class="icon" v-for="(item, index) in iconList" :key="index">
			<a href="javascript::void(0)" @click.prevent="handleShareClick(item.type)">
				<img :src="item.src">
				<span class="app-name">{{ item.name }}</span>
			</a>
			</div>
		</div>
		</div>
	</div>
	</div>
</div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import { getShareGoods, uploadImg, submitShares } from '../../../api/giftcard';

export default {
name: 'Shares',
data() {
	return {
	showModel: false,
	infos: {},
	iconList: [
		{ type: 'facebook', name: 'Facebook', src: require('../../../assets/image/giftcard/facebook.png') },
		{ type: 'telegram', name: 'Telegram', src: require('../../../assets/image/giftcard/telegram.png') },
		{ type: 'whatsapp', name: 'WhatsApp', src: require('../../../assets/image/giftcard/whatsapp.png') },
		{ type: 'instagram', name: 'Instagram', src: require('../../../assets/image/giftcard/instagram.png') },
		{ type: 'tiktok', name: 'TikTok', src: require('../../../assets/image/giftcard/tiktok.png') },
		{ type: 'youtube', name: 'YouTube', src: require('../../../assets/image/giftcard/youtube.png') },
	],
	image: null,
	imageUrl: '',
	imageVals: '',
	}
},
mounted() {
	this.getInfos();
},
methods: {
	clickShareModel(){
        this.showModel = true;
    },
    copySuccess() {
		let share_url = this.getDomain()+'/g/'
		let str = share_url + this.infos.goods_id+'\n'+this.infos.goods_name;
		this.$copyText(str).then(
			(e) => {
				Toast(this.$t('Url Copied'))
			}, (e) => {
				Toast(this.$t('err'))
			}
		);
    },
	generateShareLink(type) {
	switch (type) {
		case 'facebook':
			return this.facebookLink();
		case 'telegram':
			return this.telegramLink();
		case 'whatsapp':
			return this.whatsappLink();
		case 'instagram':
			return `https://www.instagram.com/`;
        case 'tiktok':
			return `https://www.tiktok.com/`;
        case 'youtube':
			return `https://www.youtube.com/`;
		default:
		return '#';
	}
	},
	handleShareClick(type) {
		if (type === 'instagram' || type === 'tiktok' || type === 'youtube') {
			this.copySuccess();
			this.timer = setTimeout(() => {
				window.open(this.generateShareLink(type), '_blank');
			}, 1500);
		}else{
			window.open(this.generateShareLink(type), '_blank');
		}
	},
	facebookLink() {
		const url = this.getDomain()
		const shareUrl = encodeURIComponent(`${url}/g/${this.infos.goods_id}`);
		return `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
	},
	telegramLink() {
		const url = this.getDomain()
		const shareUrl = encodeURIComponent(`${url}/g/${this.infos.goods_id}`);
		const shareText = encodeURIComponent(this.infos.goods_name);
		return `https://t.me/share/url?url=${shareUrl}&text=${shareText}`;
	},
	whatsappLink() {
		const url = this.getDomain()
		const shareText = encodeURIComponent(`Check this out: ${url}/g/${this.infos.goods_id}\n${this.infos.goods_name}`);
		return `https://api.whatsapp.com/send?text=${shareText}`;
	},
	getDomain(){
		let hostname = window.location.hostname;
		const parts = hostname.split('.').reverse();
		if (parts.length >= 2) {
			hostname = parts[1] + '.' + parts[0];
		}
		return hostname.includes('localhost') ? 'https://share.dengshop.com' : 'https://share.'+hostname;
	},
	submits() {
	if (!this.imageVals) {
		Toast(this.$t('Please upload pictures'));
		return;
	}
	Indicator.open();
	submitShares({ image: this.imageVals }).then(res => {
		Indicator.close();
		if (res.code == 10000) {
		this.$router.push({ 'name': 'GiftCardList' });
		} else {
		Toast(res.message);
		}
	}).catch(function (error) {
		Indicator.close();
		Toast(error.message);
	});
	},
	onFileChange(e) {
	const file = e.target.files[0];
	if (!file) {
		return;
	}
	Indicator.open();
	this.image = file;
	this.imageUrl = URL.createObjectURL(file);
	const formData = new FormData();
	formData.append('image', this.image);
	uploadImg(formData).then(res => {
		Indicator.close();
		this.imageVals = res.result.file;
	}).catch(()=>{
		Indicator.close();
	})
	},
	jumpShareList() {
	this.$router.push({ 'name': 'ShareList' });
	},
	getInfos() {
	getShareGoods().then(res => {
		this.infos = res.result;
	});
	},
	},
	beforeDestroy() {
    // 清除定时器以防止内存泄漏
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style scoped lang="scss">
.audit-button{
	position: fixed;
	top: 58px;
	font-size: 14px;
	right: 10px;
	z-index: 99;
	color: #ffffff;
	text-decoration: underline;
}
.app-name{
	display: block;
    font-size: 14px;
    padding-top: 5px;
    color: #000;
}
.model {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, .6);

	.model_mead {
		padding-top: 15px;
		width: 100%;
		height: 230px;
		background: #fff;
		border-radius: 12px 12px 0 0;
		position: absolute;
		bottom: 0;
		left: 0;
		.model_mead_box {
			display: flex;
			flex-wrap: wrap;
			div {
				text-align: center;
				width: 25%;
				height: 80px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 40px;
					height: 40px;
				}
			}
		}
	}
}

.box {
	background: #F0F4F7;
	width: 100%;
	overflow: hidden;
    height: 85vh;
    overflow-y: auto;
	.headerImg {
		width: 92px;
		height: 28px;
		display: block;
		margin: 20px auto;
	}

	.btns {
		text-align: center;
		padding-top: 20px;
		.btns_lf {
			display: inline-block;
			background: #E2B72B;
			border-radius: 6px;
			font-size: 18px;
			color: #FFFFFF;
			height: 30px;
			line-height: 30px;
			width: 30%;
			text-align: center;
			margin-right: 10%;
		}

		.btns_rt {
			display: inline-block;
			background: #EC5B33;
			border-radius: 6px;
			font-size: 18px;
			color: #FFFFFF;
			height: 30px;
			line-height: 30px;
			width: 30%;
			text-align: center;

		}
	}

	.headerImg2 {
		width: 100%;
		height: 240px;
		object-fit: contain;
		display: block;
		margin: 20px auto 0;
		background: #FFFAF8;
		padding-top: 20px;
	}

	.headers {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100px;
		background: #FFFAF8;
		border-radius: 0 0 15px 15px;
		padding: 10px 0;

		.header_lf {
			width: 56%;
			font-size: 16px;
			line-height: 20px;
			max-height: 100px;
			overflow: hidden;
		}

		.headers_mead {
			width: 1px;
			height: 60px;
			/* 1.94rem */
			background: rgba(220, 168, 168, 0.78);
			margin: 0 20px 0 10px;
		}

		.headers_rt {
			font-size: 16px;
			color: #EF4618;
			line-height: 21px;

			span {
				font-size: 21px;
			}
		}
	}

	.mead {
		margin-top: 10px;
		padding: 0 6px;

		.mead_tit {
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 29px;
				height: 29px;
				margin-left: 4px;
			}
		}

		.mead_txt {
			font-size: 14px;

		}

		.mead_txt2 {
			font-size: 12px;
			line-height: 20px;
		}
	}

	.upload {
		width: 96%;
		margin: 0 2%;
		background: #FFFFFF;
		border-radius: 6px;
		padding: 20px 0;
		margin-top: 10px;

		img {
			display: block;
			width: 70px;
			height: 70px;
			margin: auto;
			object-fit: contain;
		}
		.fileBox{
			width:100px; 
			height:50px; 
			position:relative;
			margin: 0 auto;
			input{
				position:absolute;
				left:0; 
				top:0; 
				opacity:0; 
				font-size: 100px;
				filter:alpha(opacity=0);
				width: 100%;
			} 
		}
		.upload_txt{
			text-align: center;
			font-weight: bold;
			font-size: 14px;
			color: #000000;
			line-height: 30px;
			margin-top: 40px;
		}
	}

	.footbtns {
		background: #EF4618;
		border-radius: 6px;
		font-size: 18px;
		color: #FFFFFF;
		height: 40px;
		line-height: 40px;
		width: 50%;
		text-align: center;
		margin: 20px auto;
	}
}
</style>
